import { sendAxiosRequest } from '../../utils/sendRequest';
import IResponse from '../../../models/responces/IResponse';
import { api } from '../../Api';
import UrlBuilder from '../../url/UrlBulder';
import IDataObject from '../../../models/restful/IDataObject';
import IDataObjectParams from '../../../models/params/IDataObjectParams';

export interface ICRUDCreateParams {
  dataObjectName: string;
  dataObject?: IDataObject;
  dataObjectParams?: IDataObjectParams;
}

const apiCreate = (params: ICRUDCreateParams) =>
  sendAxiosRequest({
    method: 'post',
    headers: { Authorization: api.getToken() },
    url: UrlBuilder.getURL({
      handler: 'crud',
      dataObjectName: params.dataObjectName,
      dataObjectParams: params.dataObjectParams || undefined
    }),
    data: params.dataObject || {},
    responseType: 'json'
  }).then(resp => resp.data) as Promise<IResponse>;
export default apiCreate;
